export default {
  featuredExperiences: 'Our Featured Experiences',
  searchAllExperiences: 'Search all Experiences',
  searchAll: 'Search All',
  groupSize: 'Group Size',
  eventSize: 'Event Size',
  upTo: 'Up to',
  whatWeDo: "What We'll Do",
  hostedBy: 'Hosted By',
  whatsIncluded: "What's Included",
  avail: 'Availability',
  whereWeAre: "Where We'll Be",
  experienceCalendar: 'Experience Calendar',
  experienceCancelled: 'Experience Canceled',
  experienceStartingPrice: 'From {{price}}',
  experienceTotalPrice: 'Total {{price}}',
  at: 'at',
  viewPrivateSessAvailability: 'View private session availability',
  selectDuration: 'Duration',
  selectStartTime: 'Start time',
  selectSession: 'Select Session',
  sessionsCount: '{{count}} times — choose a time',
  noAvailability: 'No Availability',
  select: 'Select',
  slotLeft: '{{remainSlots}} slot left',
  slotsLeft: '{{remainSlots}} slots left',
  spotsLeft: '{{count}} left',
  spotsLeftAriaLabel: '{{count}} spots remaining',
  bookExperience: 'Book Experience',
  book: 'Book',
  learnMore: 'Learn more',
  apply: 'Apply',
  maxPartySizes: 'Maximum of {{maxGroupSize}} slots per party',
  maxPartySize: 'Maximum of {{maxGroupSize}} slot per party',
  selectSessionValidation: 'Please select session',
  selectParticipantValidation: 'Please select participants',
  selectDateValidation: 'Please select date',
  reminders: 'Reminders',
  seeOtherDates: 'See other dates',
  location: 'Location',
  about: 'About',
  allExperiences: 'All experiences',
  soldOut: 'Sold Out',
  addOns: 'Add-ons',
  reviews: 'Reviews',
  reviewSingular: 'review',
  reviewPlural: 'reviews',
  dateOfExperience: 'Date of experience',
  readLess: 'Read Less',
  readMore: 'Read More',
  seeMore: 'See More',
  details: 'Details',
  durationHour: 'hour',
  durationHours: 'hours',
  durationMinutes: 'min',
  theFollowingVideoDoesNotContainAnyAudio:
    'The following video does not contain any audio',
  by: 'By',
  chooseATime: 'Choose a time for {{title}}',
  amenities: 'Amenities',
  ticketSalesOpenIn: 'Ticket sales open in',
  ticketSalesOpen: 'Ticket sales open',
  ticketSalesCloseIn: 'Ticket sales close in',
  ticketSalesClose: 'Ticket sales close',
  ticketSalesClosed: 'Ticket sales closed',
  comingSoon: 'Coming soon',
  inPartnershipWith: 'In partnership with',
  notFoundExperienceTitle: 'This experience is no longer available',
  notFoundExperienceSubtitle:
    'It may have been unpublished, or the link may no longer be valid.',
  deadLinkRecoverySubtitle: 'Discover other experiences available to book',
  catalogNotAvailable: 'This page is no longer available',
  viewAllExperiences: 'View All Experiences',
  experienceBenefits: {
    benefits: {
      basePointsEarn:
        '<p><strong>Earn 5 Base Points</strong> per eligible $1 USD spent when signing in to your World of Hyatt account to book this experience</p>',
      basePoints:
        '<p><strong>Earn 10 Base Points</strong> per eligible $1 USD spent when signing in to your World of Hyatt account to book this experience</p>',
      additionalBonusPoints:
        '<p><strong>Earn an additional 4 Bonus Points</strong> per eligible $1 USD spent when you book with your World of Hyatt Credit Card</p>',
      additionalBonusPointsTier:
        '<p><strong>Earn up to 30% additional Bonus Points</strong> depending on your tier status</p>',
      payWithPoints:
        '<p><strong>Pay with Points</strong> when booking this experience</p>',
    },
  },
};
